import React, { useEffect, useState } from 'react';
import { ColumnsType } from 'antd/lib/table';
import { RouteComponentProps, withRouter } from 'react-router';
import { TableCommon } from 'common/components/TableCommon';
import { IBaseFilterModel } from 'common/models/requestModels';
import { ERoutesPrivate } from 'common/models/routesModel';
import { objectToQuery, queryToObject } from 'common/helpers/filters.helper';
import { getBitecoinRewardCollection, setBitecoinRewardCollection } from 'app/store/reducers/bitecoin.reducer';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { EBitecoinPageTabKeys } from 'app/pages/Franchisor/BitecoinPage';
import {
  IBitecoinRewardCollection,
  IBitecoinRewardModel,
  IBitecoinRewardCollectionFilter,
} from 'entities/Bitecoin/Bitecoin.models';

interface IComponentProps {
  config: ColumnsType<any>;
  filter: IBitecoinRewardCollectionFilter;
}

type AllProps = IComponentProps & RouteComponentProps;

const BitecoinRewardsTableComponent: React.FC<AllProps> = ({ filter, config, history }) => {
  const dispatch = useAppDispatch();
  const { bitecoinRewardCollection, bitecoinRewardCollectionLoading } = useAppSelector((state) => state.bitecoin);
  const [mappedCollection, setMappedCollection] = useState<IBitecoinRewardCollection | null>(null);

  const loadCollection = (params: IBaseFilterModel) => {
    const filterParams: IBitecoinRewardCollectionFilter = { ...params };

    if (filter.search) {
      filterParams.search = filter.search;
    }
    if (filter.status) {
      filterParams.status = filter.status;
    }

    dispatch(getBitecoinRewardCollection(filterParams));
  };

  const getCollection = (bitecoinRewardCollection: IBitecoinRewardCollection | null) => {
    if (bitecoinRewardCollection?.data) {
      const mappedData: IBitecoinRewardModel[] = bitecoinRewardCollection.data.map((item) => {
        return {
          ...item,
          categoryName: item?.category?.name,
        };
      });

      return {
        ...bitecoinRewardCollection,
        data: mappedData,
      };
    } else {
      return bitecoinRewardCollection;
    }
  };

  const addQuery = (pageIndex: number) => {
    const searchPath = queryToObject({
      tab: EBitecoinPageTabKeys.RewardItems,
      pageIndex: 1,
    });
    const search = objectToQuery({ ...searchPath, pageIndex });

    return history.replace({ search });
  };

  const onRowClick = (item: IBitecoinRewardModel) => {
    history.push(`${ERoutesPrivate.BitecoinReward}/${item.id}`);
  };

  const clearCollection = () => {
    return dispatch(setBitecoinRewardCollection(null));
  };

  useEffect(() => {
    setMappedCollection(getCollection(bitecoinRewardCollection));
  }, [bitecoinRewardCollection]);

  return (
    <TableCommon
      config={config}
      filter={filter}
      collection={mappedCollection}
      loading={bitecoinRewardCollectionLoading}
      loadCollection={loadCollection}
      clearCollection={clearCollection}
      onRowClick={onRowClick}
      addQuery={addQuery}
    />
  );
};

export const BitecoinRewardsTable = withRouter(BitecoinRewardsTableComponent);
